<!--Top elements (desktop) -->
@if (!mobileResolution()) {
<app-search-panel [hidden]="navigation() || showOnMap()"></app-search-panel>
<app-profile-panel [loadingMap]="loadingMap()" [hidden]="navigation() || showOnMap()"></app-profile-panel>
}

<!--Top elements (mobile) -->
@if (mobileResolution()) {
<app-header-panel [loadingMap]="loadingMap()"
  [hidden]="navigation() || selectedDisplayMode()!=DisplayMode.RANGE || showOnMap()"></app-header-panel>
}

<!-- Cookie policy -->
@if (cookiePolicyAgreed() == false) {
<app-cookie-panel (accepted)="acceptCookies()"></app-cookie-panel>
}

<!-- Address -->
@if (showOnMap(); as shownOnMap) {
  @if (shownOnMap.type == MapElementType.Address) {
  <app-address-panel [addressType]="shownOnMap.data"></app-address-panel>
  }
}

<!-- Chargers -->
@if (showOnMap(); as shownOnMap) {
  @if (shownOnMap.type==MapElementType.FavoriteChargingStation ||
  shownOnMap.type==MapElementType.DisabledChargingStation) {
  <app-charger-panel [charger]="shownOnMap.data" [chargerType]="$any(shownOnMap.type)"></app-charger-panel>
  }
}

<!-- History -->
@if (showOnMap(); as shownOnMap) {
  @if (shownOnMap.type==MapElementType.RouteHistory) {
  <app-history-panel (loadingHistoryChanged)="loadingHistoryChanged($event)"
    [history]="shownOnMap.data"></app-history-panel>
  }
}

<!--Left sidebar-->
@if (selectedDisplayMode()==DisplayMode.ROUTE) {
<app-planning-panel [hidden]="showOnMap()" [loadingMap]="loadingMap()"></app-planning-panel>
}

<div class="ev-icon" id="slider-icon" data-testid="main-sliders-btn" (click)="toggleVehiclePanel()">
  <div class="ev-icon-circle">
    <img src="assets/icons/light/ui/sliders_icon.svg" alt="app icon" />
  </div>
</div>

<!-- Vehicle panel -->
<app-vehicle-panel [navigation]="navigation()" #vehiclePanel (closePanel)="toggleVehiclePanel()"
  [hidden]="!showVehiclePanel() || showOnMap()">
</app-vehicle-panel>

<!-- Route recalculation status -->
@if (navigationRecalculateRoute()) {
<div class="recalc-toast" role="status" aria-live="polite" data-testid="main-recalc-toast">
  <span class="recalc-toast-spinner" aria-hidden="true">
    <span class="recalc-toast-arc"></span>
  </span>
  <span class="recalc-toast-label">{{ languageService.languageJSON.Map_Recalculate }}</span>
</div>
}

<!-- Map component 
 [showSliders]="!mobileResolution() || (mobileVisiblePanel()=='car' || mobileVisiblePanel()=='car-open' || mobileVisiblePanel()=='manageVehicles')"
[loadingMap]="loadingMap()" 
-->
<app-map #map [ngClass]="{ 'disableclick': loadingMap()!=null}">
</app-map>

<!-- Wind/temp component -->
<app-wind-panel class="desktop-wind-panel" [hidden]="showOnMap() || navigation()" #windPanelComponent
  [ngClass]="{'route':  selectedDisplayMode()==DisplayMode.ROUTE}"></app-wind-panel>

<app-voice-input [hidden]="showOnMap()"></app-voice-input>

<!-- Navigation hud -->
@if (navigation()) {
<app-navigation-hud></app-navigation-hud>
}